import React, {useEffect} from "react";
import "./CollaborationPage.sass";
import {ReactComponent as Abacus} from "../../../../images/release/trainers/abacus.svg";
import {ReactComponent as Cards} from "../../../../images/release/trainers/cards.svg";
import {ReactComponent as Mental} from "../../../../images/release/trainers/mental.svg";

import Window from "../../../../_containers/window/Window";
import ButtonComponent from "../../../../_components/common/buttons/ButtonComponent";
import {ImageSliderContainer} from "../../../../_containers/imageslider/ImageSliderContainer";
import {ADDRESS} from "../../../../_api/client";
import {useNavigate} from "react-router";
import {COLLABORATION_REQUEST_PAGE} from "../../../../common/links";


export const CollaborationPage = () => {
    const top = `${ADDRESS}/images/release/collaboration/top.png`

    const first = `${ADDRESS}/images/tmp/1.jpg`
    const second = `${ADDRESS}/images/tmp/2.jpg`
    const third = `${ADDRESS}/images/tmp/3.jpg`
    const fourth = `${ADDRESS}/images/tmp/4.jpg`
    const fifth = `${ADDRESS}/images/tmp/5.jpg`
    const sixth = `${ADDRESS}/images/tmp/6.jpg`
    const seventh = `${ADDRESS}/images/tmp/9.jpg`
    const eighth = `${ADDRESS}/images/tmp/10.jpg`
    const ninth = `${ADDRESS}/images/tmp/11.jpg`
    const tenth = `${ADDRESS}/images/tmp/12.jpg`

    const blocks = [
        {
            name: "Ментальная арифметика",
            color: "#55CC80",
            Icon: Mental
        }, {
            name: "Абакус",
            color: "#8B8DF7",
            Icon: Abacus
        }, {
            name: 'Игра "Пары"',
            color: "#F7AD8B",
            Icon: Cards
        }, {
            name: 'Пирамида',
            color: "#F7BA59",
            Icon: Mental
        },
    ]

    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'КьюАй - Сотрудничество'
    }, []);

    const renderBlock = (block, i) => {
        const {Icon} = block;
        return <div key={`block-${i}`} className="CollaborationPage-block">
            <div style={{backgroundColor: block.color}}
                 className="CollaborationPage-block-icon">
                <Icon/>
            </div>
            <div className="CollaborationPage-block-title">
                {block.name}
            </div>
        </div>
    }

    return (
        <Window>
            <div className="CollaborationPage-wrapper">
                <div className="CollaborationPage-grid">
                    <div className="CollaborationPage-first-title CollaborationPage-item-title">
                        Приглашаем к сотрудничеству
                    </div>
                    <div className="CollaborationPage-first-text">
                        <div>
                            Привет, уважаемые учителя и те, кто хочет стать преподавателем ментальной арифметики!
                            Представляем вам уникальную возможность присоединиться к КьюАй и получить доступ к нашему
                            учительскому аккаунту. Здесь вы найдете все необходимое для проведения качественных занятий
                            по ментальной арифметике.
                        </div>
                        <div>
                            Даже если вы еще не знакомы с ментальной арифметикой, не беспокойтесь! Также мы предлагаем
                            обучение методике в этой области. Наши опытные методисты помогут вам освоить все необходимые
                            навыки и стратегии, чтобы вы могли проводить интересные и продуктивные уроки.
                        </div>
                        <div>
                            Присоединяйтесь к нам и станьте частью нашего сообщества преподавателей ментальной
                            арифметики. Вместе мы сможем вдохновить и развить потенциал каждого ученика. Дайте своим
                            урокам новое измерение с КьюАй!
                        </div>
                    </div>
                    <div className="CollaborationPage-first-button">
                        <ButtonComponent onClick={() => navigate(COLLABORATION_REQUEST_PAGE)}>
                            Узнать больше
                        </ButtonComponent>
                    </div>
                    <div className="CollaborationPage-first-img CollaborationPage-item-img-top">
                        <img src={top} alt="Приглашаем к сотрудничеству"/>
                    </div>
                </div>

                <div className="CollaborationPage-grid">
                    <div className="CollaborationPage-second-title CollaborationPage-item-title">Наша платформа</div>
                    <div className="CollaborationPage-second-text CollaborationPage-item-text">
                        <div>
                            На нашей платформе вы найдете все необходимое для эффективного обучения ментальной арифметике. Мы предлагаем широкий выбор материалов, тренажеров и заданий, чтобы разнообразить уроки и подстроиться под индивидуальные потребности каждого ученика. Мы также ценим значимость взаимодействия между преподавателем и учеником.
                        </div>
                        <div>
                            Будучи нашим партнером, вы получите доступ к постоянно обновляемым ресурсам и новым возможностям, чтобы вдохновить и мотивировать своих учеников. Мы с удовольствием поддерживаем преподавателей в их профессиональном росте и готовы предоставить все необходимое для успешных занятий.
                        </div>
                        <div>
                            Присоединяйтесь к нам и станьте частью нашего вдохновляющего и поддерживающего сообщества преподавателей ментальной арифметики. Развивайте потенциал своих учеников и достигайте успеха вместе с нами!
                        </div>
                    </div>
                </div>

                <div className="CollaborationPage-grid">
                    <div className="CollaborationPage-third-title">
                        <div className="CollaborationPage-item-title">Преимущества платформы</div>
                        <div className="CollaborationPage-item-text">
                            <ul>
                                <li>Интерактивные тренажеры и игры, делающие обучение увлекательным и запоминающимся.
                                </li>
                                <li>Удобная платформа для задания, проверки и отслеживания выполнения домашних
                                    заданий.
                                </li>
                                <li>Подробная статистика и отчетность о прогрессе учеников, позволяющие эффективно
                                    отслеживать успехи и адаптировать подходы к обучению.
                                </li>
                                <li>Учет баланса клиентов и гибкая система скидок учеников и их семей.</li>
                                <li>Доступ к обширной библиотеке учебных материалов для учителей.</li>
                                <li>Техническая поддержка для безопрепятственного использования платформы.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="CollaborationPage-third-img CollaborationPage-item-img-top">
                        <ImageSliderContainer
                            images={[first, second, third, fourth, fifth, sixth, seventh, eighth, ninth, tenth]}/>
                    </div>
                </div>

                <div className="CollaborationPage-grid">
                    <div className="CollaborationPage-fourth-title CollaborationPage-item-title">
                        Доступные тренажёры
                    </div>
                    <div className="CollaborationPage-fourth-text CollaborationPage-blocks">
                        {blocks.map(renderBlock)}
                    </div>
                </div>


                <div className="CollaborationPage-item-button-block">
                    <ButtonComponent onClick={() => navigate(COLLABORATION_REQUEST_PAGE)}>
                        Узнать больше
                    </ButtonComponent>
                </div>
            </div>
        </Window>
    )
}